import React from "react";
import styled from "styled-components";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { iconName, Icon } from "../../../designSystem/icons/Icons";
import { Label } from "../../../designSystem/Label";
import { P } from "../../../designSystem/typography/Body";
import { H4 } from "../../../designSystem/typography/Heading";
import { EmployeePortalPageContext } from "../../_contexts/EmployeePortalPageContext";

type PortalListRowItemProps = {
    title: string,
    description?: string,
    date?: string,
    icon: iconName,
}
export function PortalListRowItem({ title, description, date, icon }: PortalListRowItemProps): JSX.Element {
    const ctx = React.useContext(EmployeePortalPageContext);
    return (
        <ListRowItemLink>
            <Flex flexDirection='row' gap={8} justifyContent='space-between' alignItems='center' width='100%'>
                <Flex flexDirection='row' gap={8} alignItems='center' justifyContent='space-between' width='100%'>
                    <Flex flexDirection='column' gap={4} alignItems='flex-start'>
                        <H4>{title}</H4>
                        {description && <P fontSize='small'>{description}</P>}
                    </Flex>
                    {date && <Label>{date}</Label>}

                </Flex>
                <Icon name={icon} size='small' color={ctx.colors.icon.default} />
            </Flex>
        </ListRowItemLink>
    );
}

const ListRowItemLink = styled.div`
    width: 100%;
    text-decoration: none;
    transition: background-color 0.2s;

    &:hover {
        background-color: ${props => props.theme.colors.button.light.background};
        cursor: pointer;
    }
`;